/** @type {boolean} true if env is 'development' */
export const env = process.env.NODE_ENV === 'development';

/** @param {function} callback to be fired if env is development
 * @returns {boolean}
 */

export const isDevEnv = callback => {
  if (env) {
    if (typeof callback === 'function') {
      callback();
    }
    return true;
  }
  return false;
};

/** Use devMessage to provide helpful tips to developers. Use nucleus-logger for errors and warnings. devMessages only display in 'development' mode. Requires inclusion of `process.env.NODE_ENV` variable with webpack.
 * @param {string} message : Message to be displayed in console. (accepts one argument only)
 * @returns {null}*/

export function devMessage(message) {
  /* eslint-disable no-console */
  console.log(
    `%c${message}\n♡ Carina`,
    'background: #8457D9; line-height: 1.5; color: white; display: block; padding: 8px 16px;'
  );
}

export function ifDevMessage(message) {
  if (isDevEnv()) {
    devMessage(message);
  }
}
